import React, { useEffect, useState, useRef } from 'react';
import { View, Text, Pressable, StyleSheet, Icon, Icon2, Icon3 } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { loadTeamUserData, loadTeamOpenCommitmentsCombined, loadTeamCostDetailProjections, loadCostDetailBillings, loadTicketLineDetail, loadTeamCostDetailProjectionsAll, fNum, loadFTMSInvoices, loadFTMSTickets, loadTeamBillings, loadTeamBillingsMultiple, loadBillablePhases, pNum } from '../db/company';
import { dataSourceVersionAtom, isLiveVersionAtom, selectedVersionAtom, selectedTeamAtom, dataSourceJobsAtom } from '../store/company';
import moment from 'moment';

import xlsx from 'xlsx';
//import template from '../assets/rollingTemplate.xlsx';
import XLSX from 'xlsx';


const TimeMaterialsReportOld = ({ photo, view, setJobRef, job, refSubNav }) => {
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [rollingNineVersions, setRollingNineVersions] = useState([])
    const [versionInfo, setVersionInfo] = useState({})
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [invoiceData, setInvoiceData] = useState([])
    const [billingData, setBillingData] = useState([])

    const [expandRev, setExpandRev] = useState(false)
    const [expandBilling, setExpandBilling] = useState(false)
    const [expandLab, setExpandLab] = useState(false)
    const [expandEquip, setExpandEquip] = useState(false)
    const [expandMat, setExpandMat] = useState(false)
    const [expandSub, setExpandSub] = useState(false)
    const [expandSubDetail, setExpandSubDetail] = useState(false)
    const [expandOther, setExpandOther] = useState(false)
    const [jobList, setJobList] = useState([])
    const [fetchedAllJobUserData, setFetchedAllJobUserData] = useState(false)
    const [actualCosts, setActualCosts] = useState({})
    const [ticketsNotInvoiced, setTicketsNotInvoiced] = useState({})
    const [uninvoicedTickets, setUninvoicedTickets] = useState({})
    const [uninvoicedTicketsData, setUninvoicedTicketsData] = useState([])
    const [inbetweenInvoiced, setInbetweenInvoiced] = useState({})
    const [teamBillings, setTeamBillings] = useState([]);
    const [invoicedAmounts, setInvoicedAmounts] = useState({});
    const [currentEarnedAmounts, setCurrentEarnedAmounts] = useState({});
    const [billablePhases, setBillablePhases] = useState([])
    const [nonBillable, setNonBillable] = useState({})
    const [openCommitments, setOpenCommitments] = useState({})
    const [openCommitmentsJob, setOpenCommitmentsJob] = useState({})
    const [billings, setBillings] = useState({})
    const [jobTotals, setJobTotals] = useState({})
    

    // Add new state variables for non-billable sections
    const [expandNonBillable, setExpandNonBillable] = useState(false)
    const [expandNonBillableLab, setExpandNonBillableLab] = useState(false)
    const [expandNonBillableEquip, setExpandNonBillableEquip] = useState(false)
    const [expandNonBillableSub, setExpandNonBillableSub] = useState(false)
    const [expandNonBillableMat, setExpandNonBillableMat] = useState(false)
    const [expandNonBillableSubDetail, setExpandNonBillableSubDetail] = useState(false)
    const [expandNonBillableOther, setExpandNonBillableOther] = useState(false)
    const [expandTicketNotInvoiced, setExpandTicketNotInvoiced] = useState(false)
    const [costRows, setCostRows] = useState([])
    const [versionData, setVersionData] = useState([]);
    const [expandVersions, setExpandVersions] = useState(false);
    const fileInput = useRef(null);
    const [file, setFile] = useState(null);
    const [waiting, setWaiting] = useState(false)
    const tildr = useRef([])

    const fileSelectedHandler = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        uploadPowerBI(selectedFile);
    }

    const uploadPowerBI = (file = null) => {
        console.log('upload excel', file)

        if (file) {

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                const desiredColumns = [
                    'Client AFE #', 'Client PO #', 'Client WO #', 'Client Other #', 'Client Name',
                    'Job Number', 'Phase Type', 'Phase Code', 'Field Ticket Type', 'Ticket No',
                    'Ticket Date', 'Field Ticket State', 'Field Ticket Owner', 'Invoice Number',
                    'Invoice Date', 'Invoice Posting Date', 'Employee ID', 'Employee Name',
                    'Has Per Diem?', 'Is Truck Rent?', 'Is Weld Rig?', 'Labor Classification',
                    'Labor Combo Rate', 'ST Hours', 'OT Hours', 'Total Labor Hours', 'ST Rate',
                    'OT Rate', 'Daily Wage', 'Per Diem Amount', 'Labor Total', 'Equipment Description',
                    'Equipment Combo Rate', 'Unit Number', 'PO Number', 'Ticketed Hours', 'Rate',
                    'Surcharge', 'Sum of Amount', 'Material Name', 'Vendor Name', 'Vendor Invoice',
                    'Is Estimate?', 'Cost', 'Markup', 'Sales Tax', 'Material Amount', 'Description',
                    'Tax Category Name'
                ];
                const columnIndexMap = {};
                const parsedColumns = parsedData[0];
                desiredColumns.forEach((col) => {
                    const index = parsedColumns.indexOf(col);
                    if (index !== -1) {
                        columnIndexMap[col] = index;
                    }
                });

                const extractedData = parsedData.slice(1).map((row) => {
                    const rowData = {};
                    desiredColumns.forEach((col) => {
                        rowData[col] = row[columnIndexMap[col]];
                    });
                    return rowData;
                });
                console.log('extractedData', extractedData)
                //setTildr(extractedData)
            }
            reader.readAsArrayBuffer(file)
        }
    }

    const exportToExcel = async () => {
        setWaiting(true)
        const jobIds = jobList.map(job => job.BU_ID)
        // Batch loadTeamCostDetailProjectionsAll in chunks of 2 jobs
        const batchSize = 2;
        const batches = [];
        for (let i = 0; i < jobIds.length; i += batchSize) {
            batches.push(jobIds.slice(i, i + batchSize));
        }
        Promise.all(batches.map(batch => loadTeamCostDetailProjectionsAll({ ids: batch, versions: [selectedVersion] }))).then((results) => {
            const items = { data: results.flatMap(r => Array.isArray(r?.data) ? r.data : []) };
            try {

                console.log('cost data 2', items)
                //setCostRowsAll(items?.data)
                // Commenting out the template for now
                // const response = await fetch('/assets/rollingTemplate.xlsx'); // make sure it's in `public/` folder
                // const arrayBuffer = await response.arrayBuffer();
                // const workbook = xlsx.read(arrayBuffer, { type: 'array' });

                // Create a new workbook from scratch
                const workbook = xlsx.utils.book_new();

                // Add a new tab called 'tlidr' with data from ftmstickets API call
                const tlidrData = [];
                //rollingNineVersions.forEach((version) => {
                const tickets = invoiceData?.filter(ticket => ticket.Version_Guid === selectedVersion) || [];
                tickets.forEach(ticket => {
                    tlidrData.push([
                        ticket.Job_Number,
                        ticket.Ticket_Date,
                        ticket.Ticket_Status,
                        ticket.Phase_Type,
                        ticket.Total_Amount,
                        ticket.Invoice_Number || 'Uninvoiced',
                        ticket.Is_Estimation
                    ]);
                });
                //});

                // Add headers for the 'tlidr' tab
                const tlidrHeaders = ['Job Number', 'Ticket Date', 'Ticket Status', 'Phase Type', 'Total Amount', 'Invoice Number'];

                const headers = [
                    'Job Number', 'Week', 'Active / Closed', 'Client', 'Job Name',
                    'Invoiced to Date', 'Tickets Not Yet Invoiced', 'Uninvoiced Tickets', 'Inbetween Invoices', 'Current Earned',
                    'Total Billable Cost', 'Labor', 'Equipment', 'Third Party',
                    'Billable Job Profit', 'Billable Job Margin',
                    'Total Non-Billable Costs', 'OH %', 'Total Job Profit', 'Total Job Profit %', 'Other'
                ];

                const data = jobList.map(job => {
                    const v = selectedVersion;
                    const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
                    const totalBillable = (jobActualCosts.labor || 0) +
                        (jobActualCosts.equipment || 0) +
                        (jobActualCosts.thirdParty || 0);
                    const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
                    const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
                    const billableJobProfit = currentEarned - totalBillable;
                    const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;
                    const netProfit = billableJobProfit - nonBillableAmount;
                    const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;
                    const ohPercent = (nonBillableAmount / (nonBillableAmount + totalBillable)) * 100;

                    return [
                        job.BU_ID,
                        v,
                        job.Job_Status,
                        job.AR_AB_Name,
                        job.BU_Description,
                        invoicedAmounts[v]?.[job.BU_ID] || 0,
                        ticketsNotInvoiced[v]?.[job.BU_ID] || 0,
                        uninvoicedTickets[v]?.[job.BU_ID] || 0,
                        inbetweenInvoiced[v]?.[job.BU_ID] || 0,
                        currentEarned || 0,
                        totalBillable || 0,
                        jobActualCosts.labor || 0,
                        jobActualCosts.equipment || 0,
                        jobActualCosts.thirdParty || 0,
                        billableJobProfit || 0,
                        billableJobMargin.toFixed(1) + '%',
                        nonBillableAmount || 0,
                        ohPercent.toFixed(1) + '%',
                        netProfit || 0,
                        netProfitPercent.toFixed(1) + '%'
                    ];
                });

                const worksheet = xlsx.utils.aoa_to_sheet([headers, ...data]);
                xlsx.utils.book_append_sheet(workbook, worksheet, 'Summary');

                //-----------------------New Version--------------------

                //Filter cost rows and invoice data for the current version
                const currentVersion = selectedVersion;
                //console.log('cost rows', costRows[0])
                const filteredCostRowsCurrentVersion = items?.data?.filter(row => row.Version_Guid === currentVersion && ['52200', '53100', '53300', '54200', '54300', '56100', '56400', '56700'].includes(row.Cost_Type_Code));
                const filteredInvoiceDataCurrentVersion = tildr.current//?.filter(ticket => ticket['Job Number']);
                console.log('comparison lengths', filteredInvoiceDataCurrentVersion[0], filteredInvoiceDataCurrentVersion.length)

                // Update the 'Cost History - PIVOT' tab with Job_Number as the first column
                const costHistoryPivotDataCurrentVersion = {};
                const notFoundItems = [];
                filteredCostRowsCurrentVersion.forEach(row => {
                    if (row.Job_Cost) {
                        const supplier = row.Is_Credit_Card_Transaction == 'Y' ? 'Credit Card' : row.Supplier_Name?.toLowerCase() || 'Unknown';
                        const jobNumber = row.Job_Number || 'Unknown';
                        const poNumber = row.PO_Number?.replace(/^0+/, '') || 'Unknown';
                        const invoiceNumber = row.Supplier_Invoice_Number || 'Unknown';
                        const phase = row.Phase_Code || '';
                        const phaseDescription = row.Phase_Code_Description || '';
                        const costTypeDescription = row.Cost_Type_Code_Description || '';
                        const isEstimation = '';

                        if (!costHistoryPivotDataCurrentVersion[jobNumber]) {
                            costHistoryPivotDataCurrentVersion[jobNumber] = {};
                        }
                        if (!costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber]) {
                            costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber] = {
                                sumJobCost: 0,
                                sumTLIDR: 0,
                                supplier,
                                creditCard: row.Is_Credit_Card_Transaction,
                                costType: row.Cost_Type_Code,
                                phase,
                                phaseDescription,
                                costTypeDescription,
                                isEstimation
                            };
                        }
                        costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].sumJobCost += row.Job_Cost || 0;
                        // Always update phase/desc in case it's missing
                        if (!costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].phase && phase) {
                            costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].phase = phase;
                        }
                        if (!costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].phaseDescription && phaseDescription) {
                            costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].phaseDescription = phaseDescription;
                        }
                        if (!costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].costTypeDescription && costTypeDescription) {
                            costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].costTypeDescription = costTypeDescription;
                        }
                    }
                });

                filteredInvoiceDataCurrentVersion?.forEach(ticket => {
                    const jobNumber = ticket['Job_Number'] || 'Unknown';
                    const supplier = ticket['Vendor_Name']?.toLowerCase() || 'Unknown';
                    const poNumber = ticket['PO_Number'] || 'Unknown';
                    const invoiceNumber = ticket['Vendor_Invoice'] || 'Unknown';
                    const invoiceDate = ticket['Invoice_Date'] ? ticket['Invoice_Date'] : '';
                    let found = true;
                    let phase = ticket['Phase_Code'] || '';
                    let phaseDescription = ticket['Phase_Type'] || '';
                    let isEstimation = ticket['Is_Estimation'] || '';



                    if (!costHistoryPivotDataCurrentVersion[jobNumber]) {
                        costHistoryPivotDataCurrentVersion[jobNumber] = {};
                    }
                    if (invoiceNumber && !costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber]) {
                        costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber] = {
                            sumJobCost: 0,
                            sumTLIDR: 0,
                            supplier,
                            ticketLineItem: true,
                            invoicePostingDate: ticket['Invoice Posting Date'] ? moment(XLSX.SSF.parse_date_code(ticket['Invoice Posting Date'])).format('YYYY-MM-DD') : '',
                            phase,
                            phaseDescription,
                            poNumber,
                            isEstimation,
                            invoiceDate
                        };
                        found = false;
                    }

                    if (invoiceNumber) {
                        costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].sumTLIDR =
                            costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].sumTLIDR +
                            (ticket['Cost'] ? pNum(ticket['Cost']) + pNum(ticket['Sales_Tax']) : 0);
                        costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].isEstimation = ticket['Is_Estimation'] ? ticket['Is_Estimation'] : costHistoryPivotDataCurrentVersion[jobNumber][invoiceNumber].isEstimation;


                        if (!found && ticket['Cost'] > 0) {
                            notFoundItems.push({
                                jobNumber,
                                supplier,
                                poNumber,
                                invoiceNumber,
                                invoicePostingDate: ticket['Invoice Posting Date'] ? moment(XLSX.SSF.parse_date_code(ticket['Invoice Posting Date'])).format('YYYY-MM-DD') : '',
                                sumTLIDR: ticket['Cost'] + ticket['Sales_Tax'] || 0,
                                phase,
                                phaseDescription,
                                isEstimation,
                                invoiceDate
                            });
                        }
                    }
                });

                console.log('see if is estimation', costHistoryPivotDataCurrentVersion, filteredInvoiceDataCurrentVersion)

                // Update the costHistoryPivotArray to include phase, phaseDescription, costTypeDescription and remove ticketLineItem
                const costHistoryPivotArray = [];
                Object.entries(costHistoryPivotDataCurrentVersion).forEach(([jobNumber, invoices]) => {
                    Object.entries(invoices).forEach(([invoiceNumber, data]) => {
                        costHistoryPivotArray.push([
                            jobNumber,
                            data.supplier,
                            data.poNumber,
                            invoiceNumber,
                            data.sumJobCost,
                            data.sumTLIDR,
                            data.sumJobCost - data.sumTLIDR,
                            data.creditCard,
                            data.costType,
                            data.phase || '',
                            data.phaseDescription || '',
                            data.costTypeDescription || '',
                            data.isEstimation || '',
                            data.invoiceDate || '',
                        ]);
                    });
                });

                const costHistoryPivotArrayWithBillable = costHistoryPivotArray.map(row => {
                    const jobNumber = row[0];
                    const phase = row[9];
                    // Check if billablePhases has this job and phase code
                    const isBillable = !!(
                        billablePhases &&
                        billablePhases[jobNumber] &&
                        billablePhases[jobNumber][phase]
                    );
                    return [...row,  isBillable ? 'Yes' : ''];
                });

                const costHistoryHeaders = [
                    'Job Number', 'Vendor Name', 'PO Number', 'Invoice Number', 'Sum Job Cost',
                    'Sum TLIDR', 'Difference', 'Credit Card', 'Cost Type',
                    'Phase', 'Phase Description', 'Cost Type Description', 'Is Estimation', 'Invoice Date', 'Billable Phase'
                ];

                const costHistoryPivotSheetCurrentVersion = xlsx.utils.aoa_to_sheet([['Cost Detail filtered type T&M and 52200, 53100, 53300, 54200, 54300, 56100, 56400, 56700'], costHistoryHeaders, ...costHistoryPivotArrayWithBillable]);
                xlsx.utils.book_append_sheet(workbook, costHistoryPivotSheetCurrentVersion, 'Third Party Rebill Tracking');

                // Add a new sheet for Cost History with costRows that are 5* and 6*
                console.log('cost history row one ', items?.data?.[0])
                //const costHistoryFiltered = items?.data?.filter(row => /^5|6/.test(row.Cost_Type_Code));
                const costHistoryHeadersTab = Object.keys(items?.data[0] || {});
                const costHistoryData = items?.data?.map(row => {
                    const rowArr = costHistoryHeadersTab.map(header => row[header]);
                    // Add 'Billable' column: true if billablePhases has this job and phase code
                    rowArr.push(
                        !!(
                            billablePhases &&
                            billablePhases[row.Job_Number] &&
                            billablePhases[row.Job_Number][row.Phase_Code]
                        )
                    );
                    return rowArr;
                });
                costHistoryHeadersTab.push('Billable')
                const costHistorySheet = xlsx.utils.aoa_to_sheet([costHistoryHeadersTab, ...costHistoryData]);
                xlsx.utils.book_append_sheet(workbook, costHistorySheet, 'Cost History');

                console.log('tildr headers', tildr.current)

                // Add a new sheet for TLIDR with all items from tlidr
                const tlidrHeadersTab = Object.keys(tildr.current[0] || {});
                const tlidrDataTab = tildr.current?.map(row => tlidrHeadersTab.map(header => row[header]));
                const tlidrSheet = xlsx.utils.aoa_to_sheet([tlidrHeadersTab, ...tlidrDataTab]);
                xlsx.utils.book_append_sheet(workbook, tlidrSheet, 'TLIDR');

                // Update uninvoicedTicketsHeaders and mapping to match the fields above
                const uninvoicedTicketsHeaders = [
                    'AFE_Or_PO',
                    'Client_Name',
                    'Invoice_Date',
                    'Invoice_Number',
                    'Invoice_Posting_Date',
                    'Job_Number',
                    'Location',
                    'Modified_By',
                    'Owner_Name',
                    'Phase',
                    'Phase_Type',
                    'Record_Type',
                    'Special_Instructions',
                    'Ticket_Date',
                    'Ticket_Number',
                    'Ticket_Status',
                    'Ticket_Type',
                    'Total_Amount',
                    'Total_With_Estimate_Amount',
                    'Updated_Date',
                    'Version_Guid'
                ];

                const uninvoicedTicketsSheetData = [
                    uninvoicedTicketsHeaders,
                    ...uninvoicedTicketsData.map(ticket => [
                        ticket.AFE_Or_PO || '',
                        ticket.Client_Name || '',
                        ticket.Invoice_Date || '',
                        ticket.Invoice_Number || '',
                        ticket.Invoice_Posting_Date || '',
                        ticket.Job_Number || '',
                        ticket.Location || '',
                        ticket.Modified_By || '',
                        ticket.Owner_Name || '',
                        ticket.Phase || '',
                        ticket.Phase_Type || '',
                        ticket.Record_Type || '',
                        ticket.Special_Instructions || '',
                        ticket.Ticket_Date || '',
                        ticket.Ticket_Number || '',
                        ticket.Ticket_Status || '',
                        ticket.Ticket_Type || '',
                        ticket.Total_Amount || '',
                        ticket.Total_With_Estimate_Amount || '',
                        ticket.Updated_Date || '',
                        ticket.Version_Guid || ''
                    ])
                ];
                const uninvoicedTicketsSheet = xlsx.utils.aoa_to_sheet(uninvoicedTicketsSheetData);
                xlsx.utils.book_append_sheet(workbook, uninvoicedTicketsSheet, 'Uninvoiced Tickets');

                const inbetweenInvoicedSheetData = [];
                inbetweenInvoicedSheetData.push(['Version', 'Job Number', 'Inbetween Invoiced']);
                Object.entries(inbetweenInvoiced).forEach(([version, jobs]) => {
                    Object.entries(jobs).forEach(([jobNumber, value]) => {
                        inbetweenInvoicedSheetData.push([version, jobNumber, value]);
                    });
                });
                const inbetweenInvoicedSheet = xlsx.utils.aoa_to_sheet(inbetweenInvoicedSheetData);
                xlsx.utils.book_append_sheet(workbook, inbetweenInvoicedSheet, 'Inbetween Invoiced');


                if (openCommitments && Object.keys(openCommitments).length > 0) {
                    // Get all unique columns from openCommitments
                    const openCommitmentsColumns = Array.from(
                        new Set(
                            Object.values(openCommitments)
                                .flatMap(row => row && typeof row === 'object' ? Object.keys(row) : [])
                        )
                    );
                    // If openCommitments is an object of objects, convert to array of rows
                    const openCommitmentsRows = Object.entries(openCommitments).map(([jobNumber, row]) => {
                        if (row && typeof row === 'object') {
                            return openCommitmentsColumns.map(col => row[col]);
                        } else {
                            // fallback for old structure
                            return [jobNumber, row];
                        }
                    });
                    const openCommitmentsSheet = xlsx.utils.aoa_to_sheet([
                        openCommitmentsColumns,
                        ...openCommitmentsRows
                    ]);
                    xlsx.utils.book_append_sheet(workbook, openCommitmentsSheet, 'Open Commitments');
                }

                if (billings && Object.keys(billings).length > 0) {
                    // Get all unique columns from billings
                    const billingsColumns = Array.from(
                        new Set(
                            Object.values(billings)
                                .flatMap(row => row && typeof row === 'object' ? Object.keys(row) : [])
                        )
                    );
                    // If billings is an object of objects, convert to array of rows
                    const billingsRows = Object.entries(billings).map(([jobNumber, row]) => {
                        if (row && typeof row === 'object') {
                            return billingsColumns.map(col => row[col]);
                        } else {
                            // fallback for old structure
                            return [jobNumber, row];
                        }
                    });
                    const billingsSheet = xlsx.utils.aoa_to_sheet([
                        billingsColumns,
                        ...billingsRows
                    ]);
                    xlsx.utils.book_append_sheet(workbook, billingsSheet, 'Billings');
                }

                // ------------------------------------------------------------

                // //Filter cost rows and invoice data for the current version
                // const filteredCostRowsCurrentVersionThird = costRows.filter(row => row.Version_Guid === currentVersion && ['53100', '53300', '54200', '54300'].includes(row.Cost_Type_Code));
                // const filteredInvoiceDataCurrentVersionThird = tildr.filter(ticket => ticket['Job Number'] && ticket['Vendor Name']);

                // // Update the 'Cost History - PIVOT' tab with Job_Number as the first column
                // const costHistoryPivotDataCurrentVersionThird = {};
                // const notFoundItemsThird = [];
                // filteredCostRowsCurrentVersionThird.forEach(row => {
                //     if (row.Total_Job_Cost) {
                //         const supplier = row.Is_Credit_Card_Transaction == 'Y' ? 'Credit Card' : row.Supplier_Name?.toLowerCase() || 'Unknown';
                //         const jobNumber = row.Job_Number || 'Unknown';
                //         const poNumber = row.PO_Number?.replace(/^0+/, '') || 'Unknown';
                //         const invoiceNumber = row.Supplier_Invoice_Number || 'Unknown';

                //         if (!costHistoryPivotDataCurrentVersionThird[jobNumber]) {
                //             costHistoryPivotDataCurrentVersionThird[jobNumber] = {};
                //         }
                //         if (!costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber]) {
                //             costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber] = {};
                //         }
                //         if (!costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber]) {
                //             costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber] = {
                //                 sumJobCost: 0,
                //                 sumTLIDR: 0,
                //                 supplier,
                //                 creditCard: row.Is_Credit_Card_Transaction,
                //                 costType: row.Cost_Type_Code,
                //             };
                //         }
                //         costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber].sumJobCost += row.Total_Job_Cost || 0;
                //     }
                // });

                // filteredInvoiceDataCurrentVersionThird?.forEach(ticket => {
                //     const jobNumber = ticket['Job Number'] || 'Unknown';
                //     const supplier = ticket['Vendor Name']?.toLowerCase() || 'Unknown';
                //     const poNumber = ticket['PO Number'] ? ticket['PO Number'] : 'Unknown';
                //     const invoiceNumber = ticket['Vendor Invoice'] || 'Unknown';
                //     let found = true

                //     if (!costHistoryPivotDataCurrentVersionThird[jobNumber]) {
                //         costHistoryPivotDataCurrentVersionThird[jobNumber] = {};
                //     }
                //     if (!costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber]) {
                //         costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber] = {};
                //     }
                //     if (!costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber]) {
                //         costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber] = {
                //             sumJobCost: 0,
                //             sumTLIDR: 0,
                //             supplier,
                //             ticketLineItem: true,
                //             invoicePostingDate: ticket['Invoice Posting Date'] ? moment(XLSX.SSF.parse_date_code(ticket['Invoice Posting Date'])).format('YYYY-MM-DD') : '',
                //         };
                //         found = false
                //     }
                //     costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber].sumTLIDR = costHistoryPivotDataCurrentVersionThird[jobNumber][poNumber][invoiceNumber].sumTLIDR + (ticket['Cost'] ? ticket['Cost'] : 0);
                //     if (found) {
                //         console.log('matched key', jobNumber, supplier, poNumber, invoiceNumber, ticket['Cost'])
                //     } else if (ticket['Cost'] > 0) {
                //         notFoundItemsThird.push({
                //             jobNumber,
                //             supplier,
                //             poNumber,
                //             invoiceNumber,
                //             invoicePostingDate: ticket['Invoice Posting Date'] ? moment(XLSX.SSF.parse_date_code(ticket['Invoice Posting Date'])).format('YYYY-MM-DD') : '',
                //             sumTLIDR: ticket['Cost'] || 0,
                //         })
                //     }
                // });

                // // Convert the nested object structure into an array for the worksheet
                // const costHistoryPivotArrayThird = [];
                // Object.entries(costHistoryPivotDataCurrentVersionThird).forEach(([jobNumber, poNumbers]) => {
                //     Object.entries(poNumbers).forEach(([poNumber, invoices]) => {
                //         Object.entries(invoices).forEach(([invoiceNumber, data]) => {
                //             costHistoryPivotArrayThird.push([
                //                 jobNumber,
                //                 data.supplier,
                //                 poNumber,
                //                 invoiceNumber,
                //                 data.sumJobCost,
                //                 data.sumTLIDR,
                //                 data.sumJobCost - data.sumTLIDR,
                //                 data.creditCard,
                //                 data.costType,
                //                 data.ticketLineItem ? 'Yes' : 'No',
                //             ]);
                //         });
                //     });
                // });


                // const costHistoryPivotSheetCurrentVersionThird = xlsx.utils.aoa_to_sheet([['Cost Detail filtered type T&M and 53100, 53300, 54200, 54300'], costHistoryHeaders, ...costHistoryPivotArrayThird]);
                // xlsx.utils.book_append_sheet(workbook, costHistoryPivotSheetCurrentVersionThird, 'Cost History - PIVOT (2)');

                //---------------------------------------------

                // 4. Write the updated workbook to a Blob

                console.log('here', new Date())
                // const wbout = xlsx.write(workbook, { bookType: 'xlsb', type: 'binary' });
                // function s2ab(s) {
                //     const buf = new ArrayBuffer(s.length);
                //     const view = new Uint8Array(buf);
                //     for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
                //     return buf;
                // }
                // const blob = new Blob([s2ab(wbout)], {
                //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                // });
                const wbout = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([wbout], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                // 5. Trigger download
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'timeMaterialsSummary.xlsx';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

                console.log('✅ Excel downloaded');
                console.log('here 2', new Date())
                setWaiting(false)
            } catch (err) {
                console.error('❌ Error:', err);
            }
        })
    };

    // Register the export with the parent dashboard toolbar — the header
    // Download button calls childRef.current.exportToExcel(). This wiring was
    // dropped in 42eeb35 (2025-07-21), which left that button a silent no-op.
    if (refSubNav) refSubNav.current = { exportToExcel, createExcel: exportToExcel, setLoadAll: () => { } };

    const generateAndShareExcel = () => {
        const headers = [
            'Job Number', 'Week', 'Active / Closed', 'Client', 'Job Name',
            'Invoiced to Date', 'Tickets Not Yet Invoiced', 'Uninvoiced Tickets', 'Inbetween Invoices', 'Current Earned',
            'Total Billable Cost', 'Labor', 'Equipment', 'Third Party',
            'Billable Job Profit', 'Billable Job Margin',
            'Total Non-Billable Costs', 'OH %', 'Total Job Profit', 'Total Job Profit %'
        ];

        const data = jobList.flatMap(job =>
            rollingNineVersions.map(version => {
                const v = version;
                const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
                const totalBillable = (jobActualCosts.labor || 0) +
                    (jobActualCosts.equipment || 0) +
                    (jobActualCosts.thirdParty || 0);
                const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
                const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
                const billableJobProfit = currentEarned - totalBillable;
                const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;
                const netProfit = billableJobProfit - nonBillableAmount;
                const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;
                const ohPercent = (nonBillableAmount / (nonBillableAmount + totalBillable)) * 100;

                return [
                    job.BU_ID,
                    v,
                    job.Job_Status,
                    job.AR_AB_Name,
                    job.BU_Description,
                    invoicedAmounts[v]?.[job.BU_ID] || 0,
                    ticketsNotInvoiced[v]?.[job.BU_ID] || 0,
                    uninvoicedTickets[v]?.[job.BU_ID] || 0,
                    inbetweenInvoiced[v]?.[job.BU_ID] || 0,
                    currentEarned || 0,
                    totalBillable || 0,
                    jobActualCosts.labor || 0,
                    jobActualCosts.equipment || 0,
                    jobActualCosts.thirdParty || 0,
                    billableJobProfit || 0,
                    billableJobMargin.toFixed(1) + '%',
                    nonBillableAmount || 0,
                    ohPercent.toFixed(1) + '%',
                    netProfit || 0,
                    netProfitPercent.toFixed(1) + '%'
                ];
            })
        );
        const worksheet = xlsx.utils.aoa_to_sheet([headers, ...data]);
        const workbook = xlsx.utils.book_new();

        // Create a new workbook and add the worksheet
        xlsx.utils.book_append_sheet(workbook, worksheet, 'TimeMaterialsReport');

        // Write the workbook to a file
        xlsx.writeFile(workbook, 'TimeMaterialsSummary.xlsx');

    };

    useEffect(() => {
        if (!fetchedAllJobUserData && jobList?.length > 0 && selectedVersion && selectedTeam) {
            //console.log('selected version', selectedVersion)
            setFetchedAllJobUserData(true)
            const jobIds = jobList.map(job => job.BU_ID)
            const jobCostType = {}
            const billable = {}

            // Get current date and determine cutoff date for tickets
            const currentDate = moment();
            const currentDay = currentDate.day();
            let ticketCutoffDate;

            if (currentDay >= 4 || currentDay === 0) {
                ticketCutoffDate = currentDate.startOf('week');
            } else {
                ticketCutoffDate = currentDate.subtract(1, 'week').startOf('week');
            }

            loadBillablePhases({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                console.log('billable phases data:', data);
                data?.data?.forEach((d, index) => {
                    // Build billable lookup using Job_Number and Phase_Code
                    if (billable[d?.Job_Number] && billable[d?.Job_Number][d?.Phase_Code]) {
                        // Already exists
                    } else if (billable[d?.Job_Number]) {
                        billable[d?.Job_Number][d?.Phase_Code] = true
                    } else {
                        billable[d?.Job_Number] = {
                            [d?.Phase_Code]: true
                        }
                    }
                })
                console.log('billable phases structure:', billable)
                console.log('sample billable entry:', Object.keys(billable)[0] && billable[Object.keys(billable)[0]])
                setBillablePhases(billable)
            })

            // Get team billings first
            //const versionsToFetch = Array.from({ length: 7 }, (_, i) => selectedVersion - i);
            loadTeamBillingsMultiple({ ids: jobIds, versions: rollingNineVersions }).then((billingData) => {
                //console.log('billing data', billingData?.data[0])
                setBillingData(billingData?.data)
                const billingTotalsVersions = {}
                rollingNineVersions.forEach((v, index) => {

                    // Calculate billing totals by job
                    const billingTotalsByJob = billingData?.data?.filter(b => b.Version_Guid == v).reduce((acc, billing) => {
                        if (!acc[billing.Job_Number]) {
                            acc[billing.Job_Number] = 0;
                        }
                        acc[billing.Job_Number] += parseFloat(billing.Invoice_Amount || 0);
                        return acc;
                    }, {});
                    billingTotalsVersions[v] = billingTotalsByJob
                })
                setInvoicedAmounts(billingTotalsVersions);
            })

            loadFTMSTickets({ ids: jobIds, versions: rollingNineVersions }).then((data) => {
                //console.log('seth uninvoiced tickets',rollingNineVersions)
                const uninvoicedTicketsVersion = {}
                const ticketTotalsVersion = {}
                const uninvoicedTicketList = []
                //console.log('tickets data', data?.data)
                rollingNineVersions.forEach((v, index) => {
                    //console.log('seth version', v)
                    const uninvoicedTickets = {}

                    const approvedTickets = data?.data?.filter(ticket =>
                        ticket.Version_Guid == v &&
                        ['Approved', 'Ready to approve', 'Making ready'].includes(ticket.Ticket_Status) &&
                        !ticket.Invoice_Number &&
                        ticket.Phase_Type == 'T&M' &&
                        moment(ticket.Ticket_Date).isSameOrBefore(ticketCutoffDate)
                    );

                    // data?.data?.forEach(ticket => {
                    //     if (ticket.Ticket_Number === 352221544) {
                    //         if (v === 48) {
                    //             console.log('Ticket found for version 48:', ticket);
                    //         }
                    //     }
                    // });

                    //console.log('approved tickets', v, approvedTickets?.length, approvedTickets?.[0])

                    const ticketTotalsWithoutInvoice = approvedTickets?.reduce((acc, ticket) => {
                        if (!ticket.Invoice_Number) {
                            if (!acc[ticket.Job_Number]) {
                                acc[ticket.Job_Number] = [];
                            }
                            acc[ticket.Job_Number].push({ ticket, amount: ticket.Total_Amount, total: pNum(ticket.Total_Amount) + (acc[ticket.Job_Number].length > 0 ? acc[ticket.Job_Number][acc[ticket.Job_Number].length - 1].total : 0) });
                            uninvoicedTickets[ticket.Job_Number] ? uninvoicedTickets[ticket.Job_Number] = uninvoicedTickets[ticket.Job_Number] + pNum(ticket.Total_Amount) : uninvoicedTickets[ticket.Job_Number] = pNum(ticket.Total_Amount)
                            uninvoicedTicketList.push(ticket)
                        }
                        return acc;
                    }, {});
                    if (v == 53) console.log('ticket totals without invoice', v, ticketTotalsWithoutInvoice);

                    const ticketTotalsByJob = approvedTickets?.reduce((acc, ticket) => {
                        if (!acc[ticket.Job_Number]) {
                            acc[ticket.Job_Number] = 0;
                        }
                        acc[ticket.Job_Number] += parseFloat(ticket.Total_Amount || 0);
                        return acc;
                    }, {});

                    //if (v == 53) console.log('uninvoiced tickets', v, uninvoicedTickets)
                    uninvoicedTicketsVersion[v] = uninvoicedTickets
                    ticketTotalsVersion[v] = ticketTotalsByJob
                })
                setUninvoicedTickets(uninvoicedTicketsVersion)
                console.log('uninvoiced tickets', uninvoicedTicketList)
                setUninvoicedTicketsData(uninvoicedTicketList)
            })

            loadFTMSInvoices({ ids: jobIds, versions: rollingNineVersions }).then((invoiceData) => {
                //console.log('ftms in', invoiceData)
                setInvoiceData(invoiceData?.data)
            });

            setWaiting(true)
            loadTeamCostDetailProjections({ ids: jobIds, versions: rollingNineVersions }).then((data) => {
                console.log('cost data 1', data?.data[0])
                setCostRows(data?.data)
                // Calculate the cutoff date based on the selectedVersion's date
                let versionDate = null;
                if (versions && versions.length > 0) {
                    const versionObj = versions.find(v => v.Version_GUID === selectedVersion);
                    if (versionObj && versionObj.Version_Start_DateTime) {
                        versionDate = moment(versionObj.Version_Start_DateTime);
                    }
                }
                let cutoffSunday = null;
                if (versionDate) {
                    // 0 = Sunday, 4 = Thursday
                    if (versionDate.day() < 4) {
                        // Before Thursday: get previous Sunday
                        cutoffSunday = versionDate.clone().startOf('week').subtract(1, 'week');
                    } else {
                        // Thursday or after: get last Sunday (start of this week)
                        cutoffSunday = versionDate.clone().startOf('week');
                    }
                    // Example usage: console.log('Cutoff Sunday:', cutoffSunday.format('YYYY-MM-DD'));
                }
                // Batch loadTicketLineDetail in chunks of 2 jobs
                const batchSize = 2;
                const sundayStr = cutoffSunday.format('YYYY-MM-DD');
                const batches = [];
                for (let i = 0; i < jobIds.length; i += batchSize) {
                    batches.push(jobIds.slice(i, i + batchSize));
                }
                Promise.all(batches.map(batch => loadTicketLineDetail({ ids: batch, sunday: sundayStr }))).then((results) => {
                    const allData = results.flatMap(r => Array.isArray(r?.data) ? r.data : []);
                    console.log('tlidr data', allData.length, allData[0])
                    // Filter for Phase_Type 'T&M'
                    const tAndMRows = allData.filter(row => row.Phase_Type === 'T&M');
                    // Sum Material_Total, Equipment_Total, and Labor_Total for each Job_Number
                    const jobTotals = {};
                    tAndMRows.forEach(row => {
                        const jobId = row.Job_Number;
                        if (!jobTotals[jobId]) {
                            jobTotals[jobId] = {
                                material: 0,
                                equipment: 0,
                                labor: 0,
                                total: 0
                            };
                        }
                        jobTotals[jobId].material += Number(row.Material_Total) || 0;
                        jobTotals[jobId].equipment += Number(row.Equipment_Total) || 0;
                        jobTotals[jobId].labor += Number(row.Labor_Total) || 0;
                        jobTotals[jobId].total +=
                            (Number(row.Material_Total) || 0) +
                            (Number(row.Equipment_Total) || 0) +
                            (Number(row.Labor_Total) || 0);
                    });
                    setJobTotals(jobTotals);
                    setWaiting(false)
                    tildr.current = allData
                })
            })

            loadTeamOpenCommitmentsCombined({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                console.log('open commitments data', data?.data[0])
                const openCommitmentsByJob = {};
                jobIds.forEach(jobId => {
                    openCommitmentsByJob[jobId] = Array.isArray(data?.data)
                        ? data.data.filter(item => item.Job_Number === jobId && item.Cost_Type_Code[0] == '5')
                        : [];
                });
                console.log('open commitments by job', openCommitmentsByJob)
                setOpenCommitmentsJob(openCommitmentsByJob);
                setOpenCommitments(data?.data)
            })

            loadTeamBillings({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                setBillings(data?.data);
            })
        }
    }, [jobList, selectedVersion])

    useEffect(() => {
        const jobIds = jobList.map(job => job.BU_ID)
        const updatedEarnedAmountsVersion = {}
        const ticketsNotInvoicedVersion = {}
        const billingsInbetweenVersion = {}
        let specificJob = {}
        if (invoiceData?.length > 0 && billingData?.length > 0) {
            rollingNineVersions.forEach((v, index) => {

                const pendingInvoices = invoiceData?.filter(invoice => {
                    // Check if invoice exists in team billings

                    if (invoice.Version_Guid == v) {
                        const invoiceExists = billingData?.some(
                            billing => ('F00' + billing.Invoice_Number) == invoice.Invoice_Number
                        );
                        if (invoice.Job_Number == '50425009' && invoice.Version_Guid == '48') specificJob[invoice.Invoice_Number] = { invoice, invoiceExists }
                        //if(invoice.Job_Number == '54025018' && invoice.Version_Guid == '48' )console.log('a invoice', specificJob, invoice.Invoice_Subtotal_Amount, invoiceExists, invoice)

                        return invoice.Invoice_Type == 'T&M' &&
                            invoice.Invoice_Status != 'Voided' && invoice.Invoice_Status != 'Reversed' &&
                            //['Paid', 'Pending', 'Ready to Send', 'Sent'].includes(invoice.Invoice_Status) &&
                            !invoice.Posting_Date &&
                            !invoiceExists;
                    } else {
                        return false
                    }
                });
                //if (v == '53') console.log('seth 53 unin 2 part', uninvoicedTickets[v])

                // if(v == 48) {
                //     const matchedItems = [];
                //     billingData.slice(0, 10).forEach(billing => {
                //         const matchingInvoice = invoiceData?.find(
                //             invoice => ('F00' + billing.Invoice_Number) === invoice.Invoice_Number
                //         );
                //         if (matchingInvoice) {
                //             matchedItems.push({ billing, invoice: matchingInvoice });
                //             console.log('Matched Billing:', billing);
                //             console.log('Matched Invoice:', matchingInvoice);
                //         }
                //     });
                // }


                const a = []
                const invoiceTotalsByJob = pendingInvoices?.reduce((acc, invoice) => {
                    if (!acc[invoice.Job_Number]) {
                        acc[invoice.Job_Number] = 0;
                    }
                    //if(invoice.Job_Number == '54025006')console.log('invoice', invoice)
                    a[invoice.Job_Number] ? a[invoice.Job_Number].push(invoice) : a[invoice.Job_Number] = [invoice]
                    acc[invoice.Job_Number] += parseFloat(invoice.Invoice_Subtotal_Amount || 0);
                    return acc;
                }, {});

                const combinedTotalsByJob = {};
                jobIds.forEach(jobId => {
                    combinedTotalsByJob[jobId] = (uninvoicedTickets[v]?.[jobId] || 0) + (invoiceTotalsByJob[jobId] || 0);
                });

                // Fields used on invoice list
                const invoiceFields = [
                    'Version_Guid',       // Used to filter invoices by version
                    'Invoice_Number',     // Used to check if an invoice exists
                    'Invoice_Type',       // Used to filter invoices of type 'T&M'
                    'Invoice_Status',     // Used to check the status of the invoice
                    'Posting_Date',       // Used to check if the invoice has been posted
                    'Invoice_Subtotal_Amount', // Used to calculate totals by job
                    'Job_Number'          // Used to group invoices by job
                ];

                ticketsNotInvoicedVersion[v] = combinedTotalsByJob
                billingsInbetweenVersion[v] = invoiceTotalsByJob

                // Update currentEarnedAmounts after combining both tickets and invoices
                const updatedEarnedAmounts = {};
                jobIds.forEach(jobId => {
                    //console.log('current earned',  (invoicedAmounts[v]?.[jobId] || 0), combinedTotalsByJob[jobId])
                    updatedEarnedAmounts[jobId] = (invoicedAmounts[v]?.[jobId] || 0) + combinedTotalsByJob[jobId];
                });
                updatedEarnedAmountsVersion[v] = updatedEarnedAmounts

            })
            setCurrentEarnedAmounts(updatedEarnedAmountsVersion);
            setTicketsNotInvoiced(ticketsNotInvoicedVersion)
            setInbetweenInvoiced(billingsInbetweenVersion)
        }
    }, [invoiceData, billingData, invoicedAmounts, uninvoicedTickets])

    useEffect(() => {
        const nonBillableCostsVersion = {}
        const billableCostsVersion = {}
        rollingNineVersions.forEach((v, index) => {
            const nonBillableCosts = {}
            const billableCosts = {}
            //console.log('billable sections', billablePhases)
            costRows?.filter(d => d.Version_Guid == v).forEach((d, index) => {
                // Debug billable check
                const isBillable = billablePhases?.[d.Job_Number]?.[d.Phase_Code];
                if (index < 5 && v === rollingNineVersions[0]) {
                    console.log(`Cost row ${index}: Job ${d.Job_Number}, Phase ${d.Phase_Code}, Cost Type ${d.Cost_Type_Code}, Billable: ${isBillable}`);
                    console.log('Available billable phases for job:', billablePhases?.[d.Job_Number]);
                }
                if (!isBillable) {
                    //if(index == 0)console.log('d seth', d, billablePhases)
                    if (!nonBillableCosts?.[d.Job_Number]) {
                        nonBillableCosts[d.Job_Number] = { labor: 0, equipment: 0, thirdParty: 0, materials: 0, subs: 0, other: 0, total: 0 }
                    }
                    nonBillableCosts[d.Job_Number][d.Cost_Type_Code] ? nonBillableCosts[d.Job_Number][d.Cost_Type_Code] = nonBillableCosts[d.Job_Number][d.Cost_Type_Code] + d.Total_Job_Cost : nonBillableCosts[d.Job_Number][d.Cost_Type_Code] = d.Total_Job_Cost
                    if (d.Cost_Type_Code == '51100' || d.Cost_Type_Code == '51200' || d.Cost_Type_Code == '51300' || d.Cost_Type_Code == '51350' || d.Cost_Type_Code == '51400' || d.Cost_Type_Code == '51500' || d.Cost_Type_Code == '51600' || d.Cost_Type_Code == '51700' || d.Cost_Type_Code == '51800') {
                        nonBillableCosts[d.Job_Number]['labor'] = nonBillableCosts[d.Job_Number]['labor'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '52100' || d.Cost_Type_Code == '52200' || d.Cost_Type_Code == '52300' || d.Cost_Type_Code == '52400') {
                        nonBillableCosts[d.Job_Number]['equipment'] = nonBillableCosts[d.Job_Number]['equipment'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '53100' || d.Cost_Type_Code == '53200' || d.Cost_Type_Code == '53300' || d.Cost_Type_Code == '53400') {
                        nonBillableCosts[d.Job_Number]['materials'] = nonBillableCosts[d.Job_Number]['materials'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '54100' || d.Cost_Type_Code == '54200' || d.Cost_Type_Code == '54300') {
                        nonBillableCosts[d.Job_Number]['subs'] = nonBillableCosts[d.Job_Number]['subs'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '55100' || d.Cost_Type_Code == '55200' || d.Cost_Type_Code == '55300' || d.Cost_Type_Code == '55400' || d.Cost_Type_Code == '55900' || d.Cost_Type_Code == '56100' || d.Cost_Type_Code == '56500' || d.Cost_Type_Code == '57900') {
                        nonBillableCosts[d.Job_Number]['other'] = nonBillableCosts[d.Job_Number]['other'] + d.Total_Job_Cost
                    }

                    if (d.Cost_Type_Code == '53100' || d.Cost_Type_Code == '53200' || d.Cost_Type_Code == '53300' || d.Cost_Type_Code == '53400' || d.Cost_Type_Code == '54100' || d.Cost_Type_Code == '54200' || d.Cost_Type_Code == '54300' || d.Cost_Type_Code == '55100' || d.Cost_Type_Code == '55200' || d.Cost_Type_Code == '55300' || d.Cost_Type_Code == '55400' || d.Cost_Type_Code == '55900' || d.Cost_Type_Code == '56100' || d.Cost_Type_Code == '56500' || d.Cost_Type_Code == '57900') {
                        nonBillableCosts[d.Job_Number]['thirdParty'] = nonBillableCosts[d.Job_Number]['thirdParty'] + d.Total_Job_Cost
                    }

                    if (d.Cost_Type_Code[0] == '5') {
                        nonBillableCosts[d.Job_Number]['total'] = nonBillableCosts[d.Job_Number]['total'] + d.Total_Job_Cost
                    }
                } else {
                    if (!billableCosts[d.Job_Number]) {
                        billableCosts[d.Job_Number] = { labor: 0, equipment: 0, thirdParty: 0, materials: 0, subs: 0, other: 0 }
                    }
                    //if(d.Job_Number == '54024015' && d.Cost_Type_Code == '51600')console.log('d-', d.Phase_Code, d.Total_Job_Cost, d)
                    billableCosts[d.Job_Number][d.Cost_Type_Code] = (billableCosts[d.Job_Number][d.Cost_Type_Code] ? billableCosts[d.Job_Number][d.Cost_Type_Code] : 0) + pNum(d.Total_Job_Cost)
                    if (d.Cost_Type_Code[0] == '5' && d.Cost_Type_Code[1] == '1') {//1100' || d.Cost_Type_Code == '51200' || d.Cost_Type_Code == '51300' || d.Cost_Type_Code == '51400' || d.Cost_Type_Code == '51500' || d.Cost_Type_Code == '51600' || d.Cost_Type_Code == '51700'){// || d.Cost_Type_Code == '51800') {
                        billableCosts[d.Job_Number]['labor'] = billableCosts[d.Job_Number]['labor'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '52100' || d.Cost_Type_Code == '52200' || d.Cost_Type_Code == '52300' || d.Cost_Type_Code == '52400') {
                        billableCosts[d.Job_Number]['equipment'] = billableCosts[d.Job_Number]['equipment'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '53100' || d.Cost_Type_Code == '53200' || d.Cost_Type_Code == '53300' || d.Cost_Type_Code == '53400') {
                        billableCosts[d.Job_Number]['materials'] = billableCosts[d.Job_Number]['materials'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '54100' || d.Cost_Type_Code == '54200' || d.Cost_Type_Code == '54300') {
                        billableCosts[d.Job_Number]['subs'] = billableCosts[d.Job_Number]['subs'] + d.Total_Job_Cost
                    } else if (d.Cost_Type_Code == '55100' || d.Cost_Type_Code == '55200' || d.Cost_Type_Code == '55300' || d.Cost_Type_Code == '55400' || d.Cost_Type_Code == '55900' || d.Cost_Type_Code == '56100' || d.Cost_Type_Code == '56500' || d.Cost_Type_Code == '57900') {
                        billableCosts[d.Job_Number]['other'] = billableCosts[d.Job_Number]['other'] + d.Total_Job_Cost
                    }

                    if (d.Cost_Type_Code == '53100' || d.Cost_Type_Code == '53200' || d.Cost_Type_Code == '53300' || d.Cost_Type_Code == '53400' || d.Cost_Type_Code == '54100' || d.Cost_Type_Code == '54200' || d.Cost_Type_Code == '54300' || d.Cost_Type_Code == '55100' || d.Cost_Type_Code == '55200' || d.Cost_Type_Code == '55300' || d.Cost_Type_Code == '55400' || d.Cost_Type_Code == '55900' || d.Cost_Type_Code == '56100' || d.Cost_Type_Code == '56500' || d.Cost_Type_Code == '57900') {
                        billableCosts[d.Job_Number]['thirdParty'] = billableCosts[d.Job_Number]['thirdParty'] + d.Total_Job_Cost
                    }
                }
            })
            //console.log('nonBillableCosts', nonBillableCosts)
            nonBillableCostsVersion[v] = nonBillableCosts
            billableCostsVersion[v] = billableCosts
        })
        //console.log('nonBillableCosts', nonBillableCosts)
        setNonBillable(nonBillableCostsVersion)
        setActualCosts(billableCostsVersion)
    }, [costRows, billablePhases])

    useEffect(() => {
        console.log('versions', versions)
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
        const availableVersions = versions && versions.length > 0 ? versions
            .filter(version => version.Version_Type !== 'Hidden' && version.Version_GUID > 44 && version.Version_Finish_DateTime)
            .sort((a, b) => a.Version_GUID - b.Version_GUID)//sort order before slice
            .slice(-9)
            .sort((a, b) => a.Version_GUID - b.Version_GUID)//sort before dropdown
            .map(a => a.Version_GUID) : []
        //console.log('available versions', availableVersions)
        setRollingNineVersions(availableVersions);
    }, [versions, selectedVersion]);

    useEffect(() => {
        if (selectedTeam) {
            console.log('selected team', selectedTeam)
            let filtered = []
            filtered = jobs ? jobs.filter(job => job.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08 == 'T&M') : []
            console.log('jobs', filtered)
            filtered.sort((a, b) => a.BU_ID.localeCompare(b.BU_ID));
        console.log('filtered job list', filtered)
            setFetchedAllJobUserData(false)
            setJobList(filtered)
        }
    }, [jobs, selectedTeam])


    const s = StyleSheet.create({
        cell: {
            height: 20,
            border: '1px solid #aeadaf',
            padding: 2,
            fontSize: 10,
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#000'
        },
        cellt: {
            border: '1px solid #aeadaf',
            padding: 2,
            paddingBottom: 3,
            textAlign: 'right',
            fontSize: 10,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#000'
        },
        celll: {
            height: 20,
            border: '1px solid #aeadaf',
            padding: 2,
            textAlign: 'left',
            fontSize: 10,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#000'
        }
    });

    const Row = ({ job, version, first }) => {
        const [expanded, setExpanded] = useState(false);
        const v = version;
        const versionDate = versions.find(v => v.Version_GUID === version)?.Version_Start_DateTime ? moment(versions.find(v => v.Version_GUID === version)?.Version_Start_DateTime).format('M/D/YYYY') : ''


        // Calculate total billable for this job
        const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
        const totalBillable = (jobActualCosts.labor || 0) +
            (jobActualCosts.equipment || 0) +
            (jobActualCosts.thirdParty || 0);

        // Calculate OH %
        const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
        const ohPercent = (nonBillableAmount / (nonBillableAmount + totalBillable)) * 100;

        // Calculate billable job profit and margin
        const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
        const billableJobProfit = currentEarned - totalBillable;
        const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;

        // Calculate non-billable job profit and margin
        const netProfit = billableJobProfit - nonBillableAmount;
        const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;

        const openPoAmount = openCommitmentsJob[job.BU_ID]?.reduce((acc, po) => acc + (po.PO_True_Open_Amount ? pNum(po.PO_True_Open_Amount) : 0), 0) || 0

        const prevVersion = rollingNineVersions[rollingNineVersions.indexOf(v) - 1];
        const twoWeeksAgoVersion = rollingNineVersions[rollingNineVersions.indexOf(v) - 2];

        let prevBillableJobProfit = prevVersion ? (
            (currentEarnedAmounts?.[prevVersion]?.[job.BU_ID] || 0) -
            ((actualCosts?.[prevVersion]?.[job.BU_ID]?.labor || 0) +
                (actualCosts?.[prevVersion]?.[job.BU_ID]?.equipment || 0) +
                (actualCosts?.[prevVersion]?.[job.BU_ID]?.thirdParty || 0))
        ) : null;

        let prevBillableJobMargin = prevVersion && (currentEarnedAmounts?.[prevVersion]?.[job.BU_ID] || 0)
            ? ((prevBillableJobProfit / currentEarnedAmounts[prevVersion][job.BU_ID]) * 100)
            : null;

        let twoWeeksBillableJobProfit = twoWeeksAgoVersion ? (
            (currentEarnedAmounts?.[twoWeeksAgoVersion]?.[job.BU_ID] || 0) -
            ((actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.labor || 0) +
                (actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.equipment || 0) +
                (actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.thirdParty || 0))
        ) : null;

        let twoWeeksBillableJobMargin = twoWeeksAgoVersion && (currentEarnedAmounts?.[twoWeeksAgoVersion]?.[job.BU_ID] || 0)
            ? ((twoWeeksBillableJobProfit / currentEarnedAmounts[twoWeeksAgoVersion][job.BU_ID]) * 100)
            : null;

        const wkToWkGainFadeDollar = prevBillableJobProfit !== null ? fNum(billableJobProfit - prevBillableJobProfit) : '';
        const wkToWkGainFadePercent = prevBillableJobMargin !== null ? (billableJobMargin - prevBillableJobMargin).toFixed(2) + '%' : '';
        const twoWkGainFadeDollar = twoWeeksBillableJobProfit !== null ? fNum(billableJobProfit - twoWeeksBillableJobProfit) : '';
        const twoWkGainFadePercent = twoWeeksBillableJobMargin !== null ? (billableJobMargin - twoWeeksBillableJobMargin).toFixed(2) + '%' : '';

        return (
            <View>
                {first || expandVersions == job ? <View style={{ flexDirection: 'row', marginLeft: 10, backgroundColor: first ? '#ffffff' : '#f2f2f2' }}>
                    {first ? <Pressable
                        style={[s.cell, { width: 30 }]}
                        onPress={() => setExpandVersions(expandVersions == job ? false : job)}>
                        <Icon name={expandVersions == job ? "chevron-down" : "chevron-right"} size={15} color="black" />
                    </Pressable> : <View style={{ width: 30, backgroundColor: 'white' }}></View>}
                    {/* {expandVersions && versionData.map((version, index) => {
                        const versionJobData = version.data.find(d => d.BU_ID === job.BU_ID) || {};
                        return (
                            <View key={index} style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100 }]}>{`v${version.version}`}</Text>
                                <Text style={[s.cell, { width: 100 }]}>{versionJobData.Total_Job_Cost ? fNum(versionJobData.Total_Job_Cost, 1) : ''}</Text>
                            </View>
                        );
                    })} */}

                    {first ? <Text style={[s.cell, { width: 70 }]}>{job.BU_ID}</Text> : <View style={{ width: 70, backgroundColor: 'white' }}></View>}
                    <Text style={[s.cell, { width: 90 }]}>{v} - {versionDate}</Text>
                    <Text style={[s.cell, { width: 50 }]}>{job.Job_Status}</Text>
                    <Text style={[s.cell, { width: 200 }]}>{job.AR_AB_Name}</Text>
                    <Text style={[s.cell, { width: 200 }]}>{job.BU_Description}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{currentEarned ? fNum(currentEarned, 1) : ''}</Text>

                    {expandRev ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{invoicedAmounts[v]?.[job.BU_ID] ? fNum(invoicedAmounts[v]?.[job.BU_ID], 1) : ''}</Text>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{ticketsNotInvoiced[v]?.[job.BU_ID] ? fNum(ticketsNotInvoiced[v]?.[job.BU_ID], 1) : ''}</Text>
                            {expandTicketNotInvoiced && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{uninvoicedTickets[v]?.[job.BU_ID] ? fNum(uninvoicedTickets[v]?.[job.BU_ID], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{inbetweenInvoiced[v]?.[job.BU_ID] ? fNum(inbetweenInvoiced[v]?.[job.BU_ID], 1) : ''}</Text>
                                </View>
                            )}

                        </View>
                    ) : null}
                    <View style={{ width: 5 }}></View>
                    {expandBilling ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100 }]}>{totalBillable ? fNum(totalBillable, 1) : ''}</Text>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{actualCosts[v]?.[job.BU_ID]?.labor ? fNum(actualCosts[v]?.[job.BU_ID]?.labor, 1) : ''}</Text>
                            {expandLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51100'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51200'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51300'] || actualCosts[v]?.[job.BU_ID]?.['51350'] ? fNum(pNum(actualCosts[v]?.[job.BU_ID]?.['51300']) + pNum(actualCosts[v]?.[job.BU_ID]?.['51350']), 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51400'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51400'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51500'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51500'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51600'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51600'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51700'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51700'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts[v]?.[job.BU_ID]?.['51800'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51800'], 1) : ''}</Text>
                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{actualCosts[v]?.[job.BU_ID]?.equipment ? fNum(actualCosts[v]?.[job.BU_ID]?.equipment, 1) : ''}</Text>
                            {expandEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52300'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52400'], 1) : ''}</Text>
                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{actualCosts?.[v]?.[job.BU_ID]?.thirdParty ? fNum(actualCosts?.[v]?.[job.BU_ID]?.thirdParty, 1) : ''}</Text>

                            {expandSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{actualCosts?.[v]?.[job.BU_ID]?.materials ? fNum(actualCosts?.[v]?.[job.BU_ID]?.materials, 1) : ''}</Text>
                                    {expandMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53400'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{actualCosts?.[v]?.[job.BU_ID]?.subs ? fNum(actualCosts?.[v]?.[job.BU_ID]?.subs, 1) : ''}</Text>
                                    {expandSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54300'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{actualCosts?.[v]?.[job.BU_ID]?.other ? fNum(actualCosts?.[v]?.[job.BU_ID]?.other, 1) : ''}</Text>
                                    {expandOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55400'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55900'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55900'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['56100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['56100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['56500'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['56500'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['57900'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['57900'], 1) : ''}</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Text style={[s.cell, { width: 100 }]}>{totalBillable ? fNum(totalBillable, 1) : ''}</Text>
                    )}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{billableJobProfit ? fNum(billableJobProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100, backgroundColor: billableJobMargin > 40 ? '#ACF3AE' : billableJobMargin < 10 ? '#FA6B84' : '', fontWeight: 600 }]}>{billableJobMargin ? parseFloat(billableJobMargin).toFixed(1) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{nonBillable?.[v]?.[job.BU_ID]?.total ? fNum(nonBillable?.[v]?.[job.BU_ID]?.total, 1) : ''}</Text>
                    {expandNonBillable ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{nonBillable?.[v]?.[job.BU_ID]?.labor ? fNum(nonBillable?.[v]?.[job.BU_ID]?.labor, 1) : ''}</Text>
                            {expandNonBillableLab && (<View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51100'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51200'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51300'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51400'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51500'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51500'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51600'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51600'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51700'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51700'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51800'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51800'], 1) : ''}</Text>
                            </View>)}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{nonBillable?.[v]?.[job.BU_ID]?.equipment ? fNum(nonBillable?.[v]?.[job.BU_ID]?.equipment, 1) : ''}</Text>
                            {expandNonBillableEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52300'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52400'], 1) : ''}</Text>

                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{nonBillable?.[v]?.[job.BU_ID]?.thirdParty ? fNum(nonBillable?.[v]?.[job.BU_ID]?.thirdParty, 1) : ''}</Text>
                            {expandNonBillableSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{nonBillable?.[v]?.[job.BU_ID]?.materials ? fNum(nonBillable?.[v]?.[job.BU_ID]?.materials, 1) : ''}</Text>
                                    {expandNonBillableMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53400'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{nonBillable?.[v]?.[job.BU_ID]?.subs ? fNum(nonBillable?.[v]?.[job.BU_ID]?.subs, 1) : ''}</Text>
                                    {expandNonBillableSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54300'], 1) : ''}</Text>

                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{nonBillable?.[v]?.[job.BU_ID]?.other ? fNum(nonBillable?.[v]?.[job.BU_ID]?.other, 1) : ''}</Text>
                                    {expandNonBillableOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55400'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55900'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55900'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['56100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['56100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['56500'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['56500'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['57900'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['57900'], 1) : ''}</Text>

                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : null}
                    <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 2) + '%' : ''}</Text>
                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{job.nonBillableJobProfit ? fNum(job.nonBillableJobProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{job.nonBillableJobMargin ? fNum(job.nonBillableJobMargin, 1) : ''}</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{netProfit ? fNum(netProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100, backgroundColor: netProfitPercent > 40 ? '#ACF3AE' : netProfitPercent < 10 ? '#FA6B84' : '', fontWeight: 600 }]}>{netProfitPercent ? parseFloat(netProfitPercent).toFixed(1) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{wkToWkGainFadePercent}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{wkToWkGainFadeDollar}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{twoWkGainFadePercent}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{twoWkGainFadeDollar}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{openPoAmount ? fNum(openPoAmount, 1) : ''}</Text>
                </View> : null}
                {first && expandVersions == job ?
                    <View style={{ marginVertical: 20 }}>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Report Portal Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {jobTotals[job.BU_ID]?.labor ? fNum(jobTotals[job.BU_ID]?.labor, 1) : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {jobTotals[job.BU_ID]?.equipment ? fNum(jobTotals[job.BU_ID]?.equipment, 1) : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {jobTotals[job.BU_ID]?.material ? fNum(jobTotals[job.BU_ID]?.material, 1) : ''}
                                </Text>
                            </View> : null}
                        </View>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Billable Job Profit Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.labor ? fNum(jobTotals[job.BU_ID]?.labor - actualCosts[v]?.[job.BU_ID]?.labor, 1) : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.equipment ? fNum(jobTotals[job.BU_ID]?.equipment - actualCosts[v]?.[job.BU_ID]?.equipment, 1) : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.thirdParty && jobTotals[job.BU_ID]?.material ? fNum(jobTotals[job.BU_ID]?.material - actualCosts[v]?.[job.BU_ID]?.thirdParty, 1) : ''}
                                </Text>
                            </View> : null}
                        </View>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Profit Margin Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.labor ? fNum((jobTotals[job.BU_ID]?.labor - actualCosts[v]?.[job.BU_ID]?.labor) / jobTotals[job.BU_ID]?.labor * 100) + '%' : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.equipment ? fNum((jobTotals[job.BU_ID]?.equipment - actualCosts[v]?.[job.BU_ID]?.equipment) / jobTotals[job.BU_ID]?.equipment * 100) + '%' : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.thirdParty && jobTotals[job.BU_ID]?.material ? fNum((jobTotals[job.BU_ID]?.material - actualCosts[v]?.[job.BU_ID]?.thirdParty) / jobTotals[job.BU_ID]?.material * 100) + '%' : ''}
                                </Text>
                            </View> : null}
                        </View>
                    </View> : null}
            </View>
        );
    }

    const Header = () => {
        // Calculate widths for expandable sections
        const nonBillableWidth = expandNonBillable ? (
            (expandNonBillableLab ? 800 : 0) +
            (expandNonBillableEquip ? 400 : 0) +
            (expandNonBillableSub ? (
                (expandNonBillableMat ? 400 : 0) +
                (expandNonBillableSubDetail ? 300 : 0) +
                (expandNonBillableOther ? 800 : 0) +
                300
            ) : 0) +
            500
        ) : 200;

        const billableWidth = expandBilling ? (
            (expandLab ? 800 : 0) +
            (expandEquip ? 400 : 0) +
            (expandSub ? (
                (expandMat ? 400 : 0) +
                (expandSubDetail ? 300 : 0) +
                (expandOther ? 800 : 0) +
                300
            ) : 0) +
            400
        ) : 100;

        return (
            <View style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                    <Text style={[s.cellt, { width: 640, backgroundColor: '#e0e0e0' }]}></Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: expandRev ? 500 : 100, backgroundColor: '#e0e0e0' }]}>Total Revenue</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: billableWidth, backgroundColor: '#e0e0e0' }]}>Billable</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Billable Job Profit</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: nonBillableWidth, backgroundColor: '#e0e0e0' }]}>Non-Billable</Text>

                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#e0e0e0' }]}>Non-Billable</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Total Job Profit</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 400, backgroundColor: '#e0e0e0' }]}>Week to Week Change</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Other</Text>
                </View>
                <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Job Number</Text>
                    <Text style={[s.cellt, { width: 90, backgroundColor: '#e0e0e0' }]}>Week</Text>
                    <Text style={[s.cellt, { width: 50, backgroundColor: '#e0e0e0' }]}>Active / Closed</Text>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#e0e0e0' }]}>Client</Text>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#e0e0e0' }]}>Job Name</Text>
                    <View style={{ width: 5 }}></View>
                    <Pressable
                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                        onPress={() => setExpandRev(!expandRev)}>
                        <Icon name={expandRev ? "chevron-down" : "chevron-right"} size={15} color="black" />
                        <Text style={{ fontSize: 10 }}>Current Earned</Text>
                    </Pressable>
                    {expandRev ? <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Invoiced to Date</Text>
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                            onPress={() => setExpandTicketNotInvoiced(!expandTicketNotInvoiced)}>
                            <Icon name={expandTicketNotInvoiced ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Tickets Not Yet Invoiced</Text>
                        </Pressable>
                        {expandTicketNotInvoiced ? <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Uninvoiced Tickets</Text>
                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Invoices Inbetween</Text>
                        </View> : null}
                    </View> : null}
                    <View style={{ width: 5 }}></View>
                    {expandBilling ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandBilling(!expandBilling)}>
                                <Icon name={expandBilling ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Total Billable Cost</Text>
                            </Pressable>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandLab(!expandLab)}>
                                <Icon name={expandLab ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Labor</Text>
                            </Pressable>
                            {expandLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Regular Time (51100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Overtime (51200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Burden (51300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>BYOD (51400)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Per Diem (51500)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Truck Pay (51600)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Welding Rig Pay (51700)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Field Bonus (51800)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandEquip(!expandEquip)}>
                                <Icon name={expandEquip ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Equipment</Text>
                            </Pressable>
                            {expandEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Inside Equip (52100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Outside Equip (52200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Fuel (52300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Repairs (52400)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandSub(!expandSub)}>
                                <Icon name={expandSub ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Third Party</Text>
                            </Pressable>
                            {expandSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandMat(!expandMat)}>
                                        <Icon name={expandMat ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Materials</Text>
                                    </Pressable>
                                    {expandMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Materials (53100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Mats (53200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Tools & Supplies (53300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Skids (53400)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandSubDetail(!expandSubDetail)}>
                                        <Icon name={expandSubDetail ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Subs</Text>
                                    </Pressable>
                                    {expandSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Internal Subs (54100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>External Subs (54200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Hauling (54300)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandOther(!expandOther)}>
                                        <Icon name={expandOther ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Other</Text>
                                    </Pressable>
                                    {expandOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Personal Meals (55100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Team Meals (55200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Airfare (55300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Lodging (55400)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Other Travel (55900)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Field Office (56100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Safety & PPE (56500)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Misc (57900)</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                            onPress={() => setExpandBilling(!expandBilling)}>
                            <Icon name={expandBilling ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Total Billable Cost</Text>
                        </Pressable>
                    )}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Billable Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Billable Job Profit %</Text>
                    <View style={{ width: 5 }}></View>
                    {expandNonBillable ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandNonBillable(!expandNonBillable)}>
                                <Icon name={expandNonBillable ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Total Non Billable Cost</Text>
                            </Pressable>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandNonBillableLab(!expandNonBillableLab)}>
                                <Icon name={expandNonBillableLab ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Labor</Text>
                            </Pressable>
                            {expandNonBillableLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Regular Time (51100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Overtime (51200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Burden (51300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>BYOD (51400)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Per Diem (51500)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Truck Pay (51600)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Welding Rig Pay (51700)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Field Bonus (51800)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandNonBillableEquip(!expandNonBillableEquip)}>
                                <Icon name={expandNonBillableEquip ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Equipment</Text>
                            </Pressable>
                            {expandNonBillableEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Inside Equip (52100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Outside Equip (52200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Fuel (52300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Repairs (52400)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                onPress={() => setExpandNonBillableSub(!expandNonBillableSub)}>
                                <Icon name={expandNonBillableSub ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Third Party</Text>
                            </Pressable>
                            {expandNonBillableSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandNonBillableMat(!expandNonBillableMat)}>
                                        <Icon name={expandNonBillableMat ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Materials</Text>
                                    </Pressable>
                                    {expandNonBillableMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Materials (53100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Mats (53200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Tools & Supplies (53300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Skids (53400)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandNonBillableSubDetail(!expandNonBillableSubDetail)}>
                                        <Icon name={expandNonBillableSubDetail ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Subs</Text>
                                    </Pressable>
                                    {expandNonBillableSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Internal Subs (54100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>External Subs (54200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Hauling (54300)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                                        onPress={() => setExpandNonBillableOther(!expandNonBillableOther)}>
                                        <Icon name={expandNonBillableOther ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Other</Text>
                                    </Pressable>
                                    {expandNonBillableOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Personal Meals (55100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Team Meals (55200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Airfare (55300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Lodging (55400)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Other Travel (55900)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Field Office (56100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Safety & PPE (56500)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Misc (57900)</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}
                            onPress={() => setExpandNonBillable(!expandNonBillable)}>
                            <Icon name={expandNonBillable ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Total Non-Billable Costs</Text>
                        </Pressable>
                    )}
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>OH %</Text>
                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Non Billable Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Non Billable Job Margin</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Total Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0', fontWeight: 600 }]}>Total Job Profit %</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Wk to Wk Gain/(Fade) %</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Wk to Wk Gain/(Fade) $</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>2 Weeks Ago Gain/(Fade) %</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>2 Weeks Ago Gain/(Fade) $</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#e0e0e0' }]}>Open PO's</Text>

                </View>
            </View>
        )
    }


    const Footer = () => {
        // Only show footer for the most recent version (last in rollingNineVersions)
        const v = rollingNineVersions[rollingNineVersions.length - 1];
        // Totals for all jobs for the most recent version
        const totals = {
            currentEarned: 0,
            invoicedToDate: 0,
            ticketsNotYetInvoiced: 0,
            uninvoicedTickets: 0,
            inbetweenInvoiced: 0,
            totalBillableCost: 0,
            labor: 0,
            equipment: 0,
            thirdParty: 0,
            billableJobProfit: 0,
            billableJobMargin: 0,
            totalNonBillableCosts: 0,
            nonBillableLabor: 0,
            nonBillableEquipment: 0,
            nonBillableThirdParty: 0,
            nonBillableMaterials: 0,
            nonBillableSubs: 0,
            nonBillableOther: 0,
            netProfit: 0,
            netProfitPercent: 0,
            openPO: 0,
        };

        jobList.forEach(job => {
            const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
            const totalBillable = (jobActualCosts.labor || 0) +
                (jobActualCosts.equipment || 0) +
                (jobActualCosts.thirdParty || 0);
            const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
            const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
            const billableJobProfit = currentEarned - totalBillable;
            const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;
            const netProfit = billableJobProfit - nonBillableAmount;
            const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;
            const openPoAmount = openCommitmentsJob[job.BU_ID]?.reduce((acc, po) => acc + (po.PO_True_Open_Amount ? pNum(po.PO_True_Open_Amount) : 0), 0) || 0;

            totals.currentEarned += currentEarned;
            totals.invoicedToDate += invoicedAmounts[v]?.[job.BU_ID] || 0;
            totals.ticketsNotYetInvoiced += ticketsNotInvoiced[v]?.[job.BU_ID] || 0;
            totals.uninvoicedTickets += uninvoicedTickets[v]?.[job.BU_ID] || 0;
            totals.inbetweenInvoiced += inbetweenInvoiced[v]?.[job.BU_ID] || 0;
            totals.totalBillableCost += totalBillable;
            totals.labor += jobActualCosts.labor || 0;
            totals.equipment += jobActualCosts.equipment || 0;
            totals.thirdParty += jobActualCosts.thirdParty || 0;
            totals.billableJobProfit += billableJobProfit;
            totals.billableJobMargin += billableJobMargin;
            totals.totalNonBillableCosts += nonBillableAmount;
            totals.billableLabor += actualCosts[v]?.[job.BU_ID]?.labor || 0;
            totals.billableEquipment += actualCosts[v]?.[job.BU_ID]?.equipment || 0;
            totals.billableThirdParty += actualCosts[v]?.[job.BU_ID]?.thirdParty || 0;
            totals.billableMaterials += actualCosts[v]?.[job.BU_ID]?.materials || 0;
            totals.billableSubs += actualCosts[v]?.[job.BU_ID]?.subs || 0;
            totals.billableOther += actualCosts[v]?.[job.BU_ID]?.other || 0;
            totals.nonBillableLabor += nonBillable?.[v]?.[job.BU_ID]?.labor || 0;
            totals.nonBillableEquipment += nonBillable?.[v]?.[job.BU_ID]?.equipment || 0;
            totals.nonBillableThirdParty += nonBillable?.[v]?.[job.BU_ID]?.thirdParty || 0;
            totals.nonBillableMaterials += nonBillable?.[v]?.[job.BU_ID]?.materials || 0;
            totals.nonBillableSubs += nonBillable?.[v]?.[job.BU_ID]?.subs || 0;
            totals.nonBillableOther += nonBillable?.[v]?.[job.BU_ID]?.other || 0;
            totals.netProfit += netProfit;
            totals.netProfitPercent += netProfitPercent;
            totals.openPO += openPoAmount;
        });

        // Averages for margin columns
        const jobCount = jobList.length || 1;
        const avgBillableJobMargin = totals.currentEarned ? (totals.billableJobProfit / totals.currentEarned * 100) : 0;
        const avgNetProfitPercent = totals.currentEarned ? (totals.netProfit / totals.currentEarned * 100) : 0;
        const ohPercent = (totals.totalNonBillableCosts / (totals.totalNonBillableCosts + totals.totalBillableCost)) * 100;

        return (
            <View style={{ flexDirection: 'row', paddingLeft: 10, backgroundColor: '#f5f5f5', borderTop: '1px solid #ccc' }}>
                <Text style={[s.cellt, { width: 30 }]}></Text>
                <Text style={[s.cellt, { width: 70 }]}>Totals</Text>
                <Text style={[s.cellt, { width: 90 }]}></Text>
                <Text style={[s.cellt, { width: 50 }]}></Text>
                <Text style={[s.cellt, { width: 200 }]}></Text>
                <Text style={[s.cellt, { width: 200 }]}></Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.currentEarned ? fNum(totals.currentEarned, 1) : ''}</Text>
                {expandRev ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.invoicedToDate ? fNum(totals.invoicedToDate, 1) : ''}</Text>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.ticketsNotYetInvoiced ? fNum(totals.ticketsNotYetInvoiced, 1) : ''}</Text>
                        {expandTicketNotInvoiced && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{totals.uninvoicedTickets ? fNum(totals.uninvoicedTickets, 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}>{totals.inbetweenInvoiced ? fNum(totals.inbetweenInvoiced, 1) : ''}</Text>
                            </View>
                        )}
                    </View>
                ) : null}
                <View style={{ width: 5 }}></View>
                {expandBilling ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.labor ? fNum(totals.labor, 1) : ''}</Text>
                        {expandLab && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.equipment ? fNum(totals.equipment, 1) : ''}</Text>
                        {expandEquip && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.thirdParty ? fNum(totals.thirdParty, 1) : ''}</Text>
                        {expandSub && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.billableMaterials ? fNum(totals.billableMaterials, 1) : ''}</Text>
                                {expandMat && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.billableSubs ? fNum(totals.billableSubs, 1) : ''}</Text>
                                {expandSubDetail && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.billableOther ? fNum(totals.billableOther, 1) : ''}</Text>
                                {expandOther && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                ) : (
                    <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
                )}
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{totals.billableJobProfit ? fNum(totals.billableJobProfit, 1) : ''}</Text>
                <Text style={[s.cell, { width: 100, backgroundColor: avgBillableJobMargin > 40 ? '#ACF3AE' : avgBillableJobMargin < 10 ? '#FA6B84' : '', fontWeight: 600 }]}>{avgBillableJobMargin ? parseFloat(avgBillableJobMargin).toFixed(1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
                {expandNonBillable ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.nonBillableLabor ? fNum(totals.nonBillableLabor, 1) : ''}</Text>
                        {expandNonBillableLab && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.nonBillableEquipment ? fNum(totals.nonBillableEquipment, 1) : ''}</Text>
                        {expandNonBillableEquip && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#e5e7e9' }]}>{totals.nonBillableThirdParty ? fNum(totals.nonBillableThirdParty, 1) : ''}</Text>
                        {expandNonBillableSub && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.nonBillableMaterials ? fNum(totals.nonBillableMaterials, 1) : ''}</Text>
                                {expandNonBillableMat && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.nonBillableSubs ? fNum(totals.nonBillableSubs, 1) : ''}</Text>
                                {expandNonBillableSubDetail && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#bfc9ca' }]}>{totals.nonBillableOther ? fNum(totals.nonBillableOther, 1) : ''}</Text>
                                {expandNonBillableOther && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#7f8c8d' }]}></Text>
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                ) : null}
                <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{totals.netProfit ? fNum(totals.netProfit, 1) : ''}</Text>
                <Text style={[s.cell, { width: 100, backgroundColor: avgNetProfitPercent > 40 ? '#ACF3AE' : avgNetProfitPercent < 10 ? '#FA6B84' : '', fontWeight: 600 }]}>{avgNetProfitPercent ? parseFloat(avgNetProfitPercent).toFixed(1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.openPO ? fNum(totals.openPO, 1) : ''}</Text>
            </View>
        );
    };
    // const Footer = () => {
    //     // Calculate totals using the new state variables
    //     const totals = jobList.reduce((acc, job) => {
    //         if (acc && job) {
    //             return {
    //                 invoicedToDate: (acc.invoicedToDate || 0) + (invoicedAmounts[job.BU_ID] || 0),
    //                 ticketsNotYetInvoiced: (acc.ticketsNotYetInvoiced || 0) + (ticketsNotInvoiced[job.BU_ID] || 0),
    //                 currentEarned: (acc.currentEarned || 0) + (currentEarnedAmounts[job.BU_ID] || 0),
    //                 totalBillableCost: (acc.totalBillableCost || 0) + (invoicedAmounts[job.BU_ID] || 0),
    //                 currentGrossProfit: (acc.currentGrossProfit || 0) + (parseFloat(job.currentGrossProfit) || 0),
    //                 totalNonBillableCosts: (acc.totalNonBillableCosts || 0) + (parseFloat(job.totalNonBillableCosts) || 0),
    //                 nonBillableJobProfit: (acc.nonBillableJobProfit || 0) + (parseFloat(job.nonBillableJobProfit) || 0),
    //                 netProfit: (acc.netProfit || 0) + (parseFloat(job.netProfit) || 0),
    //             }
    //         }
    //     }, {});

    //     // Calculate cost type totals
    //     const costTypeTotals = Object.values(actualCosts).reduce((acc, jobCosts) => {
    //         return {
    //             labor: (acc.labor || 0) + (jobCosts.labor || 0),
    //             equipment: (acc.equipment || 0) + (jobCosts.equipment || 0),
    //             materials: (acc.materials || 0) + (jobCosts.materials || 0),
    //             subs: (acc.subs || 0) + (jobCosts.subs || 0),
    //             other: (acc.other || 0) + (jobCosts.other || 0),
    //             thirdParty: (acc.thirdParty || 0) + (jobCosts.thirdParty || 0),
    //             // Add totals for individual cost codes
    //             '51100': (acc['51100'] || 0) + (jobCosts['51100'] || 0),
    //             '51200': (acc['51200'] || 0) + (jobCosts['51200'] || 0),
    //             '51300': (acc['51300'] || 0) + (jobCosts['51300'] || 0),
    //             '51350': (acc['51350'] || 0) + (jobCosts['51350'] || 0),
    //             '51400': (acc['51400'] || 0) + (jobCosts['51400'] || 0),
    //             '51500': (acc['51500'] || 0) + (jobCosts['51500'] || 0),
    //             '51600': (acc['51600'] || 0) + (jobCosts['51600'] || 0),
    //             '51700': (acc['51700'] || 0) + (jobCosts['51700'] || 0),
    //             '51800': (acc['51800'] || 0) + (jobCosts['51800'] || 0),
    //             '52100': (acc['52100'] || 0) + (jobCosts['52100'] || 0),
    //             '52200': (acc['52200'] || 0) + (jobCosts['52200'] || 0),
    //             '52300': (acc['52300'] || 0) + (jobCosts['52300'] || 0),
    //             '52400': (acc['52400'] || 0) + (jobCosts['52400'] || 0),
    //             '53100': (acc['53100'] || 0) + (jobCosts['53100'] || 0),
    //             '53200': (acc['53200'] || 0) + (jobCosts['53200'] || 0),
    //             '53300': (acc['53300'] || 0) + (jobCosts['53300'] || 0),
    //             '53400': (acc['53400'] || 0) + (jobCosts['53400'] || 0),
    //             '54100': (acc['54100'] || 0) + (jobCosts['54100'] || 0),
    //             '54200': (acc['54200'] || 0) + (jobCosts['54200'] || 0),
    //             '54300': (acc['54300'] || 0) + (jobCosts['54300'] || 0),
    //             '55100': (acc['55100'] || 0) + (jobCosts['55100'] || 0),
    //             '55200': (acc['55200'] || 0) + (jobCosts['55200'] || 0),
    //             '55300': (acc['55300'] || 0) + (jobCosts['55300'] || 0),
    //             '55400': (acc['55400'] || 0) + (jobCosts['55400'] || 0),
    //             '55900': (acc['55900'] || 0) + (jobCosts['55900'] || 0),
    //             '56100': (acc['56100'] || 0) + (jobCosts['56100'] || 0),
    //             '56500': (acc['56500'] || 0) + (jobCosts['56500'] || 0),
    //             '57900': (acc['57900'] || 0) + (jobCosts['57900'] || 0),
    //         }
    //     }, {});

    //     // Calculate percentages
    //     const grossProfitPercent = totals.currentEarned ? ((totals.currentGrossProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const ohPercent = totals.currentEarned ? ((totals.totalNonBillableCosts / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const netProfitPercent = totals.currentEarned ? ((totals.netProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const nonBillableJobMargin = totals.currentEarned ? ((totals.nonBillableJobProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';

    //     // Calculate billable totals
    //     const billableTotals = jobList.reduce((acc, job) => {
    //         const jobActualCosts = actualCosts[job.BU_ID] || {};
    //         const totalBillable = (jobActualCosts.labor || 0) +
    //             (jobActualCosts.equipment || 0) +
    //             (jobActualCosts.thirdParty || 0);
    //         const currentEarned = currentEarnedAmounts[job.BU_ID] || 0;
    //         const billableJobProfit = currentEarned - totalBillable;

    //         return {
    //             totalBillable: (acc.totalBillable || 0) + totalBillable,
    //             totalBillableProfit: (acc.totalBillableProfit || 0) + billableJobProfit,
    //             totalEarned: (acc.totalEarned || 0) + currentEarned
    //         };
    //     }, {});

    //     // Calculate total billable margin
    //     const totalBillableMargin = billableTotals.totalEarned ?
    //         ((billableTotals.totalBillableProfit / billableTotals.totalEarned) * 100).toFixed(1) + '%' : '0%';

    //     // Calculate non-billable width for footer
    //     const nonBillableWidth = expandNonBillable ? (
    //         (expandNonBillableLab ? 800 : 0) +
    //         (expandNonBillableEquip ? 400 : 0) +
    //         (expandNonBillableSub ? (
    //             (expandNonBillableMat ? 400 : 0) +
    //             (expandNonBillableSubDetail ? 300 : 0) +
    //             (expandNonBillableOther ? 800 : 0) +
    //             300
    //         ) : 0) +
    //         400
    //     ) : 100;

    //     // Calculate billable width for footer
    //     const billableWidth = expandBilling ? (
    //         (expandLab ? 800 : 0) +
    //         (expandEquip ? 400 : 0) +
    //         (expandSub ? (
    //             (expandMat ? 400 : 0) +
    //             (expandSubDetail ? 300 : 0) +
    //             (expandOther ? 800 : 0) +
    //             300
    //         ) : 0) +
    //         400
    //     ) : 100;

    //     return (
    //         <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
    //             <Text style={[s.cellt, { width: 550, backgroundColor: '#e0e0e0' }]}>Totals</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.currentEarned ? fNum(totals.currentEarned, 1) : ''}</Text>
    //             {expandRev ? (
    //                 <View style={{ flexDirection: 'row' }}>
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.invoicedToDate ? fNum(totals.invoicedToDate, 1) : ''}</Text>
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.ticketsNotYetInvoiced ? fNum(totals.ticketsNotYetInvoiced, 1) : ''}</Text>
    //                 </View>
    //             ) : null}
    //             <View style={{ width: 5 }}></View>
    //             {/* Billable section with width calculation */}
    //             <View style={{ width: billableWidth }}>
    //                 {expandBilling ? (
    //                     <View style={{ flexDirection: 'row' }}>
    //                         <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.labor ? fNum(costTypeTotals.labor, 1) : ''}</Text>
    //                         {expandLab && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 800 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.equipment ? fNum(costTypeTotals.equipment, 1) : ''}</Text>
    //                         {expandEquip && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 400 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.thirdParty ? fNum(costTypeTotals.thirdParty, 1) : ''}</Text>
    //                         {expandSub && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.materials ? fNum(costTypeTotals.materials, 1) : ''}</Text>
    //                                 {expandMat && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 400 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.subs ? fNum(costTypeTotals.subs, 1) : ''}</Text>
    //                                 {expandSubDetail && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 300 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.other ? fNum(costTypeTotals.other, 1) : ''}</Text>
    //                                 {expandOther && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 800 }]}></Text>
    //                                     </View>
    //                                 )}
    //                             </View>
    //                         )}
    //                     </View>
    //                 ) : (
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
    //                 )}
    //             </View>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.currentGrossProfit ? fNum(totals.currentGrossProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{grossProfitPercent}</Text>
    //             <View style={{ width: 5 }}></View>
    //             {/* Non-billable section with width calculation */}
    //             <View style={{ width: nonBillableWidth }}>
    //                 {expandNonBillable ? (
    //                     <View style={{ flexDirection: 'row' }}>
    //                         <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.labor ? fNum(costTypeTotals.labor, 1) : ''}</Text>
    //                         {expandNonBillableLab && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 800 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.equipment ? fNum(costTypeTotals.equipment, 1) : ''}</Text>
    //                         {expandNonBillableEquip && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 400 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.thirdParty ? fNum(costTypeTotals.thirdParty, 1) : ''}</Text>
    //                         {expandNonBillableSub && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.materials ? fNum(costTypeTotals.materials, 1) : ''}</Text>
    //                                 {expandNonBillableMat && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 400 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.subs ? fNum(costTypeTotals.subs, 1) : ''}</Text>
    //                                 {expandNonBillableSubDetail && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 300 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.other ? fNum(costTypeTotals.other, 1) : ''}</Text>
    //                                 {expandNonBillableOther && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 800 }]}></Text>
    //                                     </View>
    //                                 )}
    //                             </View>
    //                         )}
    //                     </View>
    //                 ) : (
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
    //                 )}
    //             </View>
    //             <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 1) + '%' : ''}</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.nonBillableJobProfit ? fNum(totals.nonBillableJobProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{nonBillableJobMargin}</Text>
    //             {/* <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.netProfit ? fNum(totals.netProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{netProfitPercent}</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{billableTotals.totalBillableProfit ? fNum(billableTotals.totalBillableProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{totalBillableMargin}</Text> */}
    //         </View>
    //     );
    // }

    return (
        <View>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .spinner-icon {
                    animation: spin 1s linear infinite;
                }
            `}</style>
            <View style={{ flexDirection: 'row' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                    {versionInfo && versionInfo.Version_Start_DateTime &&
                        <View>
                            <View style={{ backgroundColor: isLiveVersion ? '#192440' : 'white', borderRadius: 5, justifyContent: 'center', padding: 10 }}>
                                <Text style={{ color: isLiveVersion ? 'white' : 'black' }}>
                                    {moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY')} {isLiveVersion ? '- Active' : ''}
                                </Text>
                            </View>
                        </View>
                    }
                    <Text style={{ fontSize: 10, paddingLeft: 30 }}>
                        {selectedTeam}
                    </Text>
                    {/* <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', marginLeft: 20 }}>
                        <Pressable
                            style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5, flexDirection: 'row', justifyContent: 'center' }}
                            onPress={() => {
                                fileInput.current.click();
                            }}
                        >
                            {tildr.length ? <Icon3
                                name="check-circle"
                                style={{ marginRight: 10 }}
                                size={20}
                                color={'green'}
                            />: null}
                            <Text>Upload TLIDR PowerBI</Text>
                        </Pressable>
                    </View>
                    <input type="file" ref={fileInput}
                        style={{ display: 'none', height: 0, width: 0 }}
                        onChange={fileSelectedHandler} accept=".xlsx" /> */}
                    <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', marginLeft: 20 }}>
                        <Pressable
                            style={{ alignItems: 'center', backgroundColor: /*tildr.length == 0 ? '#4caf50' :*/ '#e0e0e0', padding: 10, borderRadius: 5, flexDirection: 'row', justifyContent: 'center' }}
                            onPress={() => {
                                //if (tildr.length > 0) {
                                exportToExcel();
                                //} else {
                                //    alert('The selected team needs to be CSV exported from PowerBi report Field Reporting > Ticket Line Item > Consolidated.');
                                //}
                            }}
                        >
                            <Icon
                                name="↓"
                                size={18}
                                color="black"
                            />
                            {waiting ? (
                                <View style={{ marginLeft: 10 }}>
                                    <span className="spinner-icon">
                                        <Icon3 name="MdAutorenew" size={16} color="#0b142e" />
                                    </span>
                                </View>
                            ) : null}
                        </Pressable>
                    </View>
                </View>
            </View>
            <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 150 }}>
                <Header />
                {jobList.map((job, i) => (
                    <View key={i} style={{ marginBottom: 8 }}>
                        {rollingNineVersions.map((version, j) => (
                            <Row key={j} job={job} version={version} first={j === rollingNineVersions.length - 1} />
                        ))}
                    </View>
                ))}
                <Footer />
            </View>
        </View>
    );
}

export default TimeMaterialsReportOld;



